"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugifyAnnouncementTitle = exports.canUserSeeAnnouncement = exports.matchesAnnouncementAudience = exports.AnnouncementReadSchema = exports.AnnouncementReadBaseSchema = exports.AnnouncementRequestDTOSchema = exports.AnnouncementDTO = exports.AnnouncementDTOSchema = exports.AnnouncementSchema = exports.AnnouncementBaseSchema = exports.uniqueAnnouncementTags = exports.sanitizeAnnouncementTags = exports.sanitizeAnnouncementTag = exports.ANNOUNCEMENT_TAG_MAX_COUNT = exports.ANNOUNCEMENT_TAG_MAX_LENGTH = exports.AnnouncementStatus = exports.serializeAnnouncementMarkdownImage = exports.parseMarkdownImageDestination = exports.announcementImageSizeToTitle = exports.parseAnnouncementImageSize = exports.ANNOUNCEMENT_IMAGE_SIZES = exports.isAnnouncementImageKey = exports.ANNOUNCEMENT_IMAGE_QUALITY = exports.ANNOUNCEMENT_IMAGE_MAX_DIMENSION = exports.ANNOUNCEMENT_IMAGE_MAX_BYTES = exports.ANNOUNCEMENT_IMAGE_PREFIX = exports.canAuthorAnnouncements = exports.ANNOUNCEMENT_ADMIN_ROLE = void 0;
var zod_1 = require("zod");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var ObjectId_1 = require("./lib/ObjectId");
var User_1 = require("./User");
exports.ANNOUNCEMENT_ADMIN_ROLE = User_1.UserRole.Admin;
var canAuthorAnnouncements = function (role) { return (0, User_1.isAdmin)(role); };
exports.canAuthorAnnouncements = canAuthorAnnouncements;
exports.ANNOUNCEMENT_IMAGE_PREFIX = 'announcements/';
exports.ANNOUNCEMENT_IMAGE_MAX_BYTES = 5000000;
exports.ANNOUNCEMENT_IMAGE_MAX_DIMENSION = 1600;
exports.ANNOUNCEMENT_IMAGE_QUALITY = 80;
var isAnnouncementImageKey = function (value) {
    if (!value)
        return false;
    if (value.includes('..') || value.includes('\\') || /\s/.test(value))
        return false;
    if (!value.startsWith(exports.ANNOUNCEMENT_IMAGE_PREFIX))
        return false;
    return /\.(webp|jpe?g|png|gif)$/i.test(value);
};
exports.isAnnouncementImageKey = isAnnouncementImageKey;
exports.ANNOUNCEMENT_IMAGE_SIZES = ['full', 'md', 'sm'];
var ANNOUNCEMENT_IMAGE_SIZE_SET = new Set(exports.ANNOUNCEMENT_IMAGE_SIZES);
var parseAnnouncementImageSize = function (title) {
    var match = title === null || title === void 0 ? void 0 : title.trim().toLowerCase().match(/^size:(full|md|sm)$/);
    if (match && ANNOUNCEMENT_IMAGE_SIZE_SET.has(match[1]))
        return match[1];
    return 'full';
};
exports.parseAnnouncementImageSize = parseAnnouncementImageSize;
var announcementImageSizeToTitle = function (size) {
    return size === 'full' ? null : "size:".concat(size);
};
exports.announcementImageSizeToTitle = announcementImageSizeToTitle;
var parseMarkdownImageDestination = function (raw) {
    var _a;
    var trimmed = raw.trim().replace(/^<|>$/g, '');
    var withTitle = trimmed.match(/^(\S+)\s+["']([^"']+)["']$/);
    if (withTitle)
        return { src: withTitle[1], title: withTitle[2] };
    return { src: (_a = trimmed.split(/\s+/)[0]) !== null && _a !== void 0 ? _a : '' };
};
exports.parseMarkdownImageDestination = parseMarkdownImageDestination;
var serializeAnnouncementMarkdownImage = function (alt, src, title) {
    var sizeTitle = (0, exports.announcementImageSizeToTitle)((0, exports.parseAnnouncementImageSize)(title));
    return sizeTitle ? "![".concat(alt, "](").concat(src, " \"").concat(sizeTitle, "\")") : "![".concat(alt, "](").concat(src, ")");
};
exports.serializeAnnouncementMarkdownImage = serializeAnnouncementMarkdownImage;
var AnnouncementStatus;
(function (AnnouncementStatus) {
    AnnouncementStatus["Draft"] = "Draft";
    AnnouncementStatus["Published"] = "Published";
    AnnouncementStatus["Archived"] = "Archived";
})(AnnouncementStatus || (exports.AnnouncementStatus = AnnouncementStatus = {}));
exports.ANNOUNCEMENT_TAG_MAX_LENGTH = 24;
exports.ANNOUNCEMENT_TAG_MAX_COUNT = 8;
var sanitizeAnnouncementTag = function (value) {
    return value.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '').replace(/-+/g, '-').replace(/^-|-$/g, '');
};
exports.sanitizeAnnouncementTag = sanitizeAnnouncementTag;
var sanitizeAnnouncementTags = function (tags) {
    if (!(tags === null || tags === void 0 ? void 0 : tags.length))
        return [];
    var seen = new Set();
    var next = [];
    for (var _i = 0, tags_1 = tags; _i < tags_1.length; _i++) {
        var raw = tags_1[_i];
        var tag = (0, exports.sanitizeAnnouncementTag)(raw);
        if (!tag || tag.length > exports.ANNOUNCEMENT_TAG_MAX_LENGTH || seen.has(tag))
            continue;
        seen.add(tag);
        next.push(tag);
        if (next.length >= exports.ANNOUNCEMENT_TAG_MAX_COUNT)
            break;
    }
    return next;
};
exports.sanitizeAnnouncementTags = sanitizeAnnouncementTags;
var uniqueAnnouncementTags = function (announcements) {
    var seen = new Set();
    announcements.forEach(function (announcement) {
        var _a;
        ((_a = announcement.tags) !== null && _a !== void 0 ? _a : []).forEach(function (tag) {
            if (tag)
                seen.add(tag);
        });
    });
    return Array.from(seen).sort(function (a, b) { return a.localeCompare(b); });
};
exports.uniqueAnnouncementTags = uniqueAnnouncementTags;
exports.AnnouncementBaseSchema = zod_1.z.object({
    title: zod_1.z.string().min(1).max(200),
    slug: zod_1.z
        .string()
        .min(1)
        .max(200)
        .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Slug must be lowercase letters, numbers, and hyphens'),
    summary: zod_1.z.string().min(20).max(300),
    body: zod_1.z.string().min(1),
    coverImageKey: zod_1.z.string().optional(),
    tags: zod_1.z.array(zod_1.z.string()).default([]),
    status: zod_1.z.nativeEnum(AnnouncementStatus).default(AnnouncementStatus.Draft),
    publishedAt: zod_1.z.coerce.date().nullish(),
    authorId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    audienceTypeSlugs: zod_1.z.array(zod_1.z.string()).min(1, 'At least one audience type is required'),
});
exports.AnnouncementSchema = exports.AnnouncementBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
exports.AnnouncementDTOSchema = exports.AnnouncementSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelDTOFields), { authorId: (0, ObjectId_1.ObjectIdString)('Invalid authorId'), publishedAt: zod_1.z.string().nullish() }));
exports.AnnouncementDTO = {
    convertFromModel: function (model) {
        var _a, _b;
        return {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            title: model.title,
            slug: model.slug,
            summary: model.summary,
            body: model.body,
            coverImageKey: model.coverImageKey,
            tags: (_a = model.tags) !== null && _a !== void 0 ? _a : [],
            status: model.status,
            publishedAt: model.publishedAt ? model.publishedAt.toISOString() : null,
            authorId: model.authorId.toString(),
            audienceTypeSlugs: (_b = model.audienceTypeSlugs) !== null && _b !== void 0 ? _b : [],
        };
    },
};
exports.AnnouncementRequestDTOSchema = exports.AnnouncementDTOSchema.extend(CommonMongoModelFields_1.CommonModelRequestDTOFields).omit({
    authorId: true,
});
exports.AnnouncementReadBaseSchema = zod_1.z.object({
    userId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    announcementId: zod_1.z.instanceof(ObjectId_1.ObjectId),
    seenAt: zod_1.z.coerce.date(),
});
exports.AnnouncementReadSchema = exports.AnnouncementReadBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
/**
 * Returns true when the announcement is visible to the user's current membership.
 * Audience is expected to be non-empty; empty arrays are treated as legacy "all members".
 */
var matchesAnnouncementAudience = function (currentMembership, audienceTypeSlugs) {
    var _a;
    if (!audienceTypeSlugs || audienceTypeSlugs.length === 0)
        return true;
    if (!currentMembership)
        return false;
    var slug = (_a = currentMembership.membershipTypeSlug) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    var type = currentMembership.membershipType;
    return audienceTypeSlugs.some(function (audience) {
        var normalized = audience.toLowerCase();
        if (slug && slug === normalized)
            return true;
        return type === audience;
    });
};
exports.matchesAnnouncementAudience = matchesAnnouncementAudience;
var canUserSeeAnnouncement = function (role, currentMembership, audienceTypeSlugs) {
    if ((0, User_1.isAdmin)(role))
        return true;
    return (0, exports.matchesAnnouncementAudience)(currentMembership, audienceTypeSlugs);
};
exports.canUserSeeAnnouncement = canUserSeeAnnouncement;
var slugifyAnnouncementTitle = function (title) {
    return title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
};
exports.slugifyAnnouncementTitle = slugifyAnnouncementTitle;
//# sourceMappingURL=Announcement.js.map